import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { selectIsAuthenticated } from "../../store/slices/authSlice";
import { PUBLIC_ROUTES } from "../../config";

const ProtectedRoute = ({ children }) => {
	const isAuthenticated = useSelector(selectIsAuthenticated);
	if (!isAuthenticated) {
		return <Navigate to={PUBLIC_ROUTES.LOGIN} replace />;
	}
	return children;
};

export default ProtectedRoute;
